import { createApp } from 'vue';
import AccessoriesSelector from '../components/AccessoriesSelector.vue';

// Mount app when DOM is ready
const mountElement = document.getElementById('accessories-app');
if (mountElement) {
    const apiUrl = mountElement.dataset.apiUrl;
    const category = mountElement.dataset.category || '';
    const translations = mountElement.dataset.translations
        ? JSON.parse(mountElement.dataset.translations)
        : {};

    const app = createApp(AccessoriesSelector, {
        apiUrl: apiUrl,
        category: category,
        translations: translations,
    });

    app.mount('#accessories-app');
}
